/**
 * Vaulzo logo mark + wordmark, identical to the one in the dashboard
 * header so the landing page and app read as the same product.
 */
export default function VaulzoLogo({ className = "" }) {
  return (
    <span className={`flex items-center gap-[11px] ${className}`}>
      <span className="flex h-7 w-7 flex-none items-center justify-center rounded-lg bg-vaulzo-ink">
        <span className="h-[9px] w-[9px] rounded-full border-2 border-vaulzo-bg" />
      </span>
      <span className="text-[15px] font-semibold text-vaulzo-ink">Vaulzo</span>
    </span>
  );
}
